module.exports = __webpack_public_path__ + "static/img/yzlogo.8297babb.png";